import Rails from "@rails/ujs"
import "../components/custom-confirm"

if (!window._rails_loaded) Rails.start()
